// ─────────────────────────────────────────────────────────────────
// Glass-i — UOM Master frontend constants (Stage 6B.8A-1).
//
// MEASUREMENT_TYPES is the same controlled vocabulary as the backend
// (lockstep with uom.constants.js + migration 0026 CHECK constraint).
// ─────────────────────────────────────────────────────────────────

export const MEASUREMENT_TYPES = Object.freeze([
  'area', 'quantity', 'length', 'weight',
  'volume', 'package', 'service', 'time', 'other'
]);

export const MEASUREMENT_TYPE_OPTIONS = Object.freeze([
  { value: 'area',     label: 'Area' },
  { value: 'quantity', label: 'Quantity' },
  { value: 'length',   label: 'Length' },
  { value: 'weight',   label: 'Weight' },
  { value: 'volume',   label: 'Volume' },
  { value: 'package',  label: 'Package' },
  { value: 'service',  label: 'Service' },
  { value: 'time',     label: 'Time' },
  { value: 'other',    label: 'Other' }
]);

// Visual color palette for measurement-type tags in the grid.
export const MEASUREMENT_TYPE_COLOR = Object.freeze({
  area:     'cyan',
  quantity: 'blue',
  length:   'geekblue',
  weight:   'purple',
  volume:   'magenta',
  package:  'orange',
  service:  'green',
  time:     'gold',
  other:    'default'
});
